import React, { useEffect, useState } from "react";
import "./item-details.css";
import { useParams } from "react-router";
import ItemDetailsTop from "./components/item-details-top";
import ItemDetailsBody from "./components/item-details-body";
import {
  GetIouItemInfo,
  GetRewardInfo,
  GetShareItemInfo,
  GetUserInfo,
} from "../../utils/firebase-config";
import { ThreeCircles } from "react-loader-spinner";
import BottomModal from "../../components/bottom-modal/bottom-modal";
import ItemDetailsRewardInformation from "./components/item-details-reward-information";
import ItemDetailsShareItem from "./components/item-details-share-item";
import ItemDetailsUser from "./components/item-details-user";
import { useNavigate } from "react-router";
const ItemDetails = () => {
  const { itemId } = useParams();
  const [itemInfo, setItemInfo] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [rewardInfo, setRewardInfo] = useState(null);
  const [showRewardModal, setShowRewardModal] = useState(false);
  const [type, setType] = useState(null);
  const pulledData = React.useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const type = itemId.split(":")[1];
    const typeId = itemId.split(":")[2];

    const fetchItemInfo = async () => {
      setType(type);
      if (type === "iou") {
        const itemInfo = await GetIouItemInfo(typeId);
        if (!itemInfo) {
          navigate("/error");
          return;
        }
        setItemInfo(itemInfo);
        pulledData.current = true;
        console.log(itemInfo);
        if (itemInfo.toId) {
          const rewardInfo = await GetRewardInfo(itemInfo.toId);
          setRewardInfo(rewardInfo);
        }
      } else if (type === "shareItem") {
        const itemInfo = await GetShareItemInfo(typeId);
        if (!itemInfo) {
          navigate("/error");
          return;
        }
        setItemInfo(itemInfo);
        pulledData.current = true;
        console.log(itemInfo);
      } else if (type === "user" || type === "storeCheckIn") {
        const userInfo = await GetUserInfo(typeId);
        if (!userInfo) {
          navigate("/error");
          return;
        }
        setItemInfo(userInfo);
        pulledData.current = true;
        console.log(userInfo);
      } else {
        navigate("/error");
        return;
      }
      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
    };
    if (!pulledData.current) {
      fetchItemInfo();
    }
  }, [itemId]);

  console.log(rewardInfo, "rewardInfo");

  return (
    <div className="item-details-container">
      {isLoading ? (
        <div className="item-details-wrapper">
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <ThreeCircles
                visible={true}
                height="70"
                width="70"
                color="#000000"
                ariaLabel="three-circles-loading"
                wrapperStyle={{}}
                wrapperClass=""
              />
              <p
                style={{
                  fontSize: "15px",
                  fontWeight: "400",
                  color: "#000000",
                }}
              >
                Loading item details...
              </p>
            </div>
          </div>
        </div>
      ) : type === "iou" ? (
        <div className="item-details-wrapper">
          <ItemDetailsTop
            itemInfo={itemInfo}
            rewardInfo={rewardInfo}
            showRewardModal={() => setShowRewardModal(true)}
          />
          <ItemDetailsBody itemInfo={itemInfo} />
        </div>
      ) : type === "shareItem" ? (
        <div className="item-details-wrapper">
          <ItemDetailsShareItem itemInfo={itemInfo} />
        </div>
      ) : type === "user" || type === "storeCheckIn" ? (
        <div className="item-details-wrapper">
          <ItemDetailsUser itemInfo={itemInfo} />
        </div>
      ) : null}
      {showRewardModal && (
        <BottomModal
          onClose={() => setShowRewardModal(false)}
          title={"Reward Information"}
        >
          <ItemDetailsRewardInformation rewardInfo={rewardInfo} />
        </BottomModal>
      )}
    </div>
  );
};

export default ItemDetails;
